// Formatting helpers. Money is in mcents: 1 mcent = 1/100,000 USD.

export function usd(mcents: number | null | undefined): string {
  const v = (mcents ?? 0) / 100_000;
  return v.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: Math.abs(v) < 1 ? 4 : 2,
  });
}

// Dollars (user-entered) → mcents.
export function dollarsToMcents(dollars: number): number {
  return Math.round(dollars * 100_000);
}

export function tokens(n: number | null | undefined): string {
  const v = n ?? 0;
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
  return String(Math.round(v));
}

export function num(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString();
}

export function date(ms: number | null | undefined): string {
  if (!ms) return "—";
  return new Date(ms).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function dateTime(ms: number | null | undefined): string {
  if (!ms) return "—";
  return new Date(ms).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
